import commonMapping from "@/mapping/common";

const control_type_list = [
  { id: "tm_tvolume", value: "volume", config: "volume", label: "traffic_volumn_ctrl" },
  { id: "tm_conntime", value: "time", config: "time", label: "traffic_time_ctrl" },
];

const volume_type_list = [
  { value: "No limit", config: "unlimit", label: "traffic_nolimit" },
  { value: "Download only", label: "traffic_download", config: "download" },
  { value: "Both directions", label: "traffic_dir", config: "bidirection" },
];

const ampm_list = [
  { value: "0", label: "am_mark", config: "0" },
  { value: "1", label: "pm_mark", config: "1" },
];

const reset_counter_day_list = [
  { value: "1", label: "day_1st", config: "1" },
  { value: "2", label: "day_2nd", config: "2" },
  { value: "3", label: "day_3rd", config: "3" },
  { value: "4", label: "day_4th", config: "4" },
  { value: "5", label: "day_5th", config: "5" },
  { value: "6", label: "day_6th", config: "6" },
  { value: "7", label: "day_7th", config: "7" },
  { value: "8", label: "day_8th", config: "8" },
  { value: "9", label: "day_9th", config: "9" },
  { value: "10", label: "day_10th", config: "10" },
  { value: "11", label: "day_11th", config: "11" },
  { value: "12", label: "day_12th", config: "12" },
  { value: "13", label: "day_13th", config: "13" },
  { value: "14", label: "day_14th", config: "14" },
  { value: "15", label: "day_15th", config: "15" },
  { value: "16", label: "day_16th", config: "16" },
  { value: "17", label: "day_17th", config: "17" },
  { value: "18", label: "day_18th", config: "18" },
  { value: "19", label: "day_19th", config: "19" },
  { value: "20", label: "day_20th", config: "20" },
  { value: "21", label: "day_21st", config: "21" },
  { value: "22", label: "day_22nd", config: "22" },
  { value: "23", label: "day_23rd", config: "23" },
  { value: "24", label: "day_24th", config: "24" },
  { value: "25", label: "day_25th", config: "25" },
  { value: "26", label: "day_26th", config: "26" },
  { value: "27", label: "day_27th", config: "27" },
  { value: "28", label: "day_28th", config: "28" },
  { value: "31", label: "last", config: "31" },
];

export const traffic = {
  traffic_enable: commonMapping.intToBoolean,
  control_type: control_type_list,
  volume_type: volume_type_list,
  ampm: ampm_list,
  reset_counter_day: reset_counter_day_list,
  blink_internet_led_enable: commonMapping.intToBoolean,
  disconn_internet_enable: commonMapping.intToBoolean,
};

export default traffic;
